module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bigDataShow",
    attrs: {
      "id": "bigData"
    }
  }, [_c('h1', {
    staticClass: "bigTitle"
  }, [_vm._v("大数据可视化平台"), _c('i', {
    staticClass: "border_bottom"
  })]), _vm._v(" "), _c('p', {
    staticClass: "underInfo"
  }, [_vm._v("海量车辆轨迹位置数据展示，助您分析决策")]), _vm._v(" "), _c('ul', {
    staticClass: "listUl"
  }, [_c('li', [_c('img', {
    staticClass: "backgroungImg",
    attrs: {
      "src": require("../../../static/images/index/1.jpg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "center-title"
  }, [_vm._v("位置覆盖图")])]), _vm._v(" "), _c('li', [_c('img', {
    staticClass: "backgroungImg",
    attrs: {
      "src": require("../../../static/images/index/2.jpg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "center-title"
  }, [_vm._v("区域覆盖图")])]), _vm._v(" "), _c('li', [_c('img', {
    staticClass: "backgroungImg",
    attrs: {
      "src": require("../../../static/images/index/3.jpg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "center-title"
  }, [_vm._v("路网覆盖图")])])]), _vm._v(" "), _c('p', {
    staticClass: "common_button"
  }, [_c('a', {
    attrs: {
      "href": "http://v.ishowchina.com/",
      "target": "_blank"
    }
  }, [_vm._v("查看详情")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-734721aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/bigDataShow.vue
// module id = 139
// module chunks = 1